export default "__VITE_PUBLIC_ASSET__6f6a5e00__"